import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button } from '../../components/common/atom/Button';
import { Text } from '../../components/common/atom/Text';
import { Flex } from '../../components/common/atom/Layout';
import Loading from '../../components/common/organism/Loading';
import ImageUpload, { ULTRASOUND } from './ImageUpload';

import ImageFileContext from '../../modules/contexts/ImageFile';
import { ERROR_REFRESH, ERROR_RETRY } from '../../lib/Error';
import * as api from '../../lib/api/api';
import { reloadUltrasound } from './ImageAPI';

const ImageList = ({
  itemId,
  imageType,
  updateAvailable,
  multipleOption,
  limitedNum,
}) => {
  const [imageList, setImageList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modifyAvailable, setModifyAvailable] = useState(false);
  const { state, actions } = useContext(ImageFileContext);

  useEffect(() => {
    switch (imageType) {
      case ULTRASOUND:
        getUltrasound(itemId);
        break;
      default:
        alert(ERROR_REFRESH);
    }
  }, [modifyAvailable]);

  const getUltrasound = (itemId) => {
    api.getUltrasound({ itemId: itemId }).then((response) => {
      setImageList(response.data);
    });
  };

  const doImageFilesReload = () => {
    const fileList = state.ultraList;
    if (fileList.length > 0) {
      setLoading(true);

      let files = new FormData();
      for (let i = 0; i < fileList.length; i++) {
        files.append('files', fileList[i], fileList[i].name.split('.')[0]); // 원본 이미지
      }

      switch (imageType) {
        case ULTRASOUND:
          reloadUltrasound({ itemId: itemId, files: files })
            .then((res) => {
              setLoading(false);
              setModifyAvailable(false);
            })
            .then(() => {
              actions.setUltraList([]);
              actions.setUltraPreviewList([]);
            })
            .catch((e) => {
              console.log(e);
              alert(ERROR_RETRY);
              setLoading(false);
            });
          break;
        default:
          alert(ERROR_REFRESH);
          setLoading(false);
      }
    } else {
      alert('초음파 사진 첨부하기를 눌러 사진 업로드 후 다시 시도해주세요.');
    }
  };

  return (
    <>
      {loading ? (
        <Loading onlyLoader padding="6rem" />
      ) : (
        <>
          {modifyAvailable ? (
            <ImageUpload
              imageType={imageType}
              multipleOption={multipleOption}
              limitedNum={limitedNum}
            />
          ) : (
            <ImageBox>
              {imageList &&
                imageList.map((image, index) => {
                  const { id, storageUri } = image.image;
                  return (
                    <ImageContainer key={id}>
                      {imageType === ULTRASOUND && imageList.length > 1 ? (
                        <IndexIcon>{index + 1}</IndexIcon>
                      ) : (
                        ''
                      )}
                      <ImageStyle src={storageUri} />
                    </ImageContainer>
                  );
                })}
            </ImageBox>
          )}
          {updateAvailable &&
            (modifyAvailable ? (
              <Button
                color="brownGrey"
                style={{
                  width: '50%',
                  alignSelf: 'center',
                  marginTop: '1.25rem',
                  marginBottom: '1.25rem',
                }}
                onClick={() => doImageFilesReload()}
              >
                제출하기
              </Button>
            ) : (
              <Button
                style={{
                  width: '50%',
                  alignSelf: 'center',
                  marginBottom: '1.25rem',
                }}
                onClick={() => {
                  if (
                    window.confirm(
                      '사진을 모두 삭제하고 다시 올리시겠습니까?',
                    ) === false
                  )
                    return;
                  setModifyAvailable(true);
                }}
              >
                <Text size={14}>사진 다시 올리기</Text>
              </Button>
            ))}
        </>
      )}
    </>
  );
};

export default React.memo(ImageList);

ImageList.propTypes = {
  itemId: PropTypes.number.isRequired,
  imageType: PropTypes.string.isRequired,
};

const ImageBox = styled(Flex)`
  width: 100%;
  min-height: 172px;
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(88, 82, 105, 0.28);
  background-color: #f6f7fb;
  padding: 10px;
  margin-bottom: 25px;
  flex-wrap: wrap;
  margin-top: 10px;
`;

const ImageContainer = styled.div`
  position: relative;
  margin: 5px;
`;

const IndexIcon = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  background-color: #ff0266;
  font-size: 14px;
  color: #ffffff;
`;

const ImageStyle = styled.img`
  width: 200px;
  height: 200px;
  margin: ${(props) => props.margin};
  object-fit: ${(props) => props.objectFit || 'contain'};
`;
